/** Extract YouTube video ID from common URL formats; returns null if not YouTube. */
export const getYouTubeVideoId = (url) => {
  if (!url || typeof url !== "string") return null;
  const s = url.trim();
  const m = s.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
};

/** Embed URL with explicit controls; wider preview surfaces the full bar (gear → quality & playback speed on desktop). */
export const buildYouTubeEmbedSrc = (videoId, { autoplay = false } = {}) => {
  const q = new URLSearchParams({
    rel: "0",
    controls: "1",
    fs: "1",
    playsinline: "1",
    modestbranding: "1",
    disablekb: "0",
  });
  if (autoplay) q.set("autoplay", "1");
  return `https://www.youtube.com/embed/${videoId}?${q}`;
};

export const YOUTUBE_IFRAME_ALLOW =
  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen; compute-pressure";
